import { ReactComponent as LoaderSvg } from 'images/loader.svg'

import style from './Button.module.css'

type ButtonDotsLoaderProps = {
  className?: string
}

/** Nine pink dots — same asset as page Loader. */
export function ButtonDotsLoader({ className }: ButtonDotsLoaderProps) {
  return <LoaderSvg className={className ?? style.dotsLoader} aria-hidden />
}
